import React from 'react'
import Helmet from 'react-helmet';

export default ({metadata, hero, heroPosition}) => {
    var heroStyle = {};

    if (hero !== undefined) {
        heroPosition = heroPosition?heroPosition:"70%"
        heroStyle = {
            "background": "url('/images/hero/" + hero + "')",
            "backgroundPosition": "center " + heroPosition,
            "backgroundSize": "cover"
        }            
    }

    return (
    <header className="bodyHeader" style={heroStyle}>
        <Helmet>
            {(hero) ? 
                <meta property="og:image" content={"https://www.paulkimbrel.com/images/hero/" + hero} />
            : 
                <meta property="og:image" content="https://www.paulkimbrel.com/images/self-pk.jpg" />
            }
        </Helmet>
        <div className="container">
            <div className="row">
                <div className="col-sm-3">
                    <a href="/"><img className="profile-image img-circle" src="/images/profile-pic.jpeg" alt="Paul Kimbrel" /></a>
                </div>
                <div className="col-sm-9 profile-container">
                    <div className="profile">
                        <h1 className="title"><a href="/">{metadata.title}</a></h1>
                        <h2 className="desciption">{metadata.subtitle}</h2>
                        <ul className="global-social list-inline">
                            <li>
                                <a href="https://www.twitter.com/pkimbrel" target="_blank"><i className="fa fa-twitter"></i></a>
                            </li>
                            <li>
                                <a href="http://instagram.com/pkimbrel" target="_blank"><i className="fa fa-instagram"></i></a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/in/pkimbrel/" target="_blank"><i className="fa fa-linkedin-square"></i></a>
                            </li>
                            <li>
                                <a href="https://soundcloud.com/paul-kimbrel" target="_blank"><i className="fa fa-soundcloud"></i></a>
                            </li>
                            <li>
                                <a href="https://plus.google.com/114118871174996663491/posts" target="_blank"><i className="fa fa-google-plus-square"></i></a>
                            </li>
                            <li>
                                <a href="https://github.com/pkimbrel" target="_blank"><i className="fa fa-github"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>
)}
    


// WEBPACK FOOTER //
// ./src/components/header.js